export const colors = {
    gold: '#fffb00',
    red: '#ff002f',
    pink: '#f700ff',
    purple: '#9400ff',
    blue: '#0073ff',
    lightBlue: '#0bf'
}